import { render, staticRenderFns } from "./ProjectRateSetting.vue?vue&type=template&id=50cd82c8&scoped=true&"
import script from "./ProjectRateSetting.vue?vue&type=script&lang=js&"
export * from "./ProjectRateSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRateSetting.vue?vue&type=style&index=0&id=50cd82c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd82c8",
  null
  
)

export default component.exports